"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*---------------------------------------------*/
var StackSpacer = /*#__PURE__*/function (_Component) {
  _inherits(StackSpacer, _Component);

  var _super = _createSuper(StackSpacer);

  function StackSpacer() {
    _classCallCheck(this, StackSpacer);

    return _super.apply(this, arguments);
  }

  _createClass(StackSpacer, [{
    key: "render",
    value: function render() {
      var height = this.props.height || 'm';
      var style = {
        height: "var(--space-stack-".concat(height, ")")
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        style: style
      });
    }
  }]);

  return StackSpacer;
}(_component.default);
/*---------------------------------------------*/


var Stack = /*#__PURE__*/function (_Component2) {
  _inherits(Stack, _Component2);

  var _super2 = _createSuper(Stack);

  function Stack() {
    _classCallCheck(this, Stack);

    return _super2.apply(this, arguments);
  }

  _createClass(Stack, [{
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.addClass('lth-spacing-' + (this.props.spacing || 'normal'));
      var fieldClassName = this.constructor.BASE_CLASS + '__field';

      var fields = _react.default.Children.map(this.props.children, function (child, index, list) {
        var _child$props;

        var customSpacing = (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.spacing ? 'lth-spacing-' + child.props.spacing : '';
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(fieldClassName, " ").concat(customSpacing)
        }, child);
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClassNames(),
        style: this.getStyle()
      }, fields);
    }
  }]);

  return Stack;
}(_component.default);

exports.default = Stack;

_defineProperty(Stack, "BASE_CLASS", 'lth-l-stack');

Stack.Spacer = StackSpacer;
/*---------------------------------------------*/

Stack.METADATA = {
  name: 'Stack',
  description: 'Use to alternate among related views within the same context.',
  props: [{
    name: 'spacing',
    type: 'string',
    description: 'Choose the spacing between the stack elements',
    value: 'normal',
    options: [{
      value: 'dense'
    }, {
      value: 'compact'
    }, {
      value: 'normal'
    }, {
      value: 'comfortable'
    }, {
      value: 'spaced'
    }]
  }],

  get demo() {
    // for some reason when adding demo as a regular member React complaints about type error
    return {
      content: [/*#__PURE__*/_react.default.createElement(_.Input, {
        type: "text",
        label: "Your name",
        key: "name"
      }), /*#__PURE__*/_react.default.createElement(_.Input, {
        type: "number",
        label: "Your age",
        key: "age",
        spacing: "spaced"
      }), /*#__PURE__*/_react.default.createElement(_.Button, {
        label: "Submit",
        key: "submit"
      })]
    };
  }

};